import Main from '@/components/main/Main';
// 支付模块的路由
export default [
  {
    name: 'dmp_material',
    path: '/dmp/material',
    component: Main,
    redirect: '/dmp/material/group',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '素材库',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'dmp_material_group',
        path: '/dmp/material/group',
        component: () => import('@/emc-dmp/views/dmpmaterialgroup'),
        meta: {
          showInMenu: true,
          path: '/dmp/material/group',
          title: '素材库',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_material_group_add',
        path: '/dmp/material/group/add',
        component: () => import('@/emc-dmp/views/dmpmaterialgroup/EditPage'),
        meta: {
          showInMenu: false,
          path: '/dmp/material/group/add',
          title: '新增素材库',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_material_title',
        path: '/dmp/material/title',
        component: () => import('@/emc-dmp/views/title-material'),
        meta: {
          showInMenu: true,
          path: '/dmp/material/title',
          title: '标题',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_material_title_add',
        path: '/dmp/material/title/add',
        component: () => import('@/emc-dmp/views/title-material/EditPage'),
        meta: {
          showInMenu: false
        }
      },
      {
        name: 'dmp_landing_page',
        path: '/dmp/landing/page',
        component: () => import('@/emc-dmp/views/dmplandingpage'),
        meta: {
          showInMenu: true,
          path: '/dmp/landing/page',
          title: '落地页',
          icon: 'logo-apple'
        }
      }
    ]
  }
];
